import { useState } from "react";
import { Link } from "react-router-dom";

interface ServiceCardProps {
  title: string;
  items: string[];
  slug: string;
  numeral: string;
}

const ServiceCard = ({ title, items, slug, numeral }: ServiceCardProps) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      style={{
        padding: "40px 32px",
        borderRight: "0.5px solid rgba(212,168,67,0.18)",
        background: hovered ? "#0E0E0E" : "transparent",
        transition: "background 0.3s",
        flex: 1,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span
        style={{
          fontFamily: "'Barlow Condensed', sans-serif",
          fontWeight: 700,
          fontSize: 11,
          color: "#D4A843",
          letterSpacing: "0.2em",
        }}
      >
        {numeral}
      </span>
      <h3
        style={{
          fontFamily: "'Playfair Display', serif",
          fontWeight: 300,
          fontSize: "clamp(28px, 3vw, 48px)",
          color: "#F8F4EC",
          marginTop: 16,
          marginBottom: 24,
          lineHeight: 1.1,
        }}
      >
        {title}
      </h3>
      <ul style={{ listStyle: "none", padding: 0, marginBottom: 32 }}>
        {items.map((item, i) => (
          <li
            key={i}
            style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: 14,
              color: hovered ? "#F8F4EC" : "#908A83",
              lineHeight: 2,
              transition: `color 0.2s ${i * 30}ms`,
            }}
          >
            {item}
          </li>
        ))}
      </ul>
      <Link
        to={slug}
        style={{
          fontFamily: "'Barlow Condensed', sans-serif",
          fontWeight: 700,
          fontSize: 11,
          color: "#D4A843",
          letterSpacing: "0.2em",
          textTransform: "uppercase",
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        EXPLORE <span style={{ fontSize: 16 }}>→</span>
      </Link>
    </div>
  );
};

export default ServiceCard;
